import React, { useRef, useState } from "react";
import MicRecorder from "mic-recorder-to-mp3";
import { transcribe } from "../../../Actions/ChatActions";
import AudioRecorder from "../AudioRecorder/AudioRecorder";
import { getUserToken } from "../../../Actions/Utils";
import RecordedAudioText from "../RecordedAudioText/RecordedAudioText";
import MicropohneOnboarding from "../MicrophoneOnboarding/MicrophoneOnboarding";
import { useNavigate } from "react-router-dom";
import { ToastSeverityMap } from "../../../NewConstants/ToastConstants";
import { trackEvent } from "../../../Actions/Utils";
const onboarding_delay = process.env.REACT_APP_ONBOARDING_DELAY;
const ChatInputButton = ({
  selectedLanguageCode,
  input,
  setInput = () => {},
  setAudioArr= () => {},
  audioArr,
  send = () => {},
  adjustTextareaHeight = () => {},
  isLoading,
  audioRef,
  stopPlayingAudio = () => {},
  setSpeakerEnabled = () => {},
  setToastErrorMessage = () => {},
  setShowToastMessage = () => {},
  setToastMessageSeverity = () => {},
  sendClickedFunction = () => {}
}) => {
  let navigate = useNavigate();
  const normalizedInput = typeof input === "string" ? input.trim() : "";
  const [isRecording, setIsRecording] = useState(false);
  const [isRecordOnboarding, setIsRecordOnboarding] = useState(false);
  const [Mp3Recorder, setMp3Recorder] = useState(
    new MicRecorder({ bitRate: 128 })
  );
  const [recordingTime, setRecordingTime] = useState(0);
  const recorderRef = useRef(null);
  const [audioText, setAudioText] = useState("");
  const [processAudio, setProcessAudio] = useState(false);
  
  const startRecording = async () => {
    try {
      // Check microphone permissions
      const status = await navigator.permissions.query({ name: 'microphone' });
      if (status.state) {
        await Mp3Recorder.start();
        setIsRecording(true);
        recorderRef.current = setInterval(() => {
          setRecordingTime((prevTime) => prevTime + 1);
        }, 1000);
      }
      else {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach(track => track.stop());
        await Mp3Recorder.start();
        setIsRecording(true);
        recorderRef.current = setInterval(() => {
          setRecordingTime((prevTime) => prevTime + 1);
        }, 1000);
      }
    } catch (error) {
      setRecordingTime(0);
      setToastErrorMessage("Please allow microphone");
      setToastMessageSeverity(ToastSeverityMap.error);
      setShowToastMessage(true);
      setInput("");
      setIsRecording(false);
      setAudioText("");
      setProcessAudio(false);
      setRecordingTime(0);
    }
  };
  const handleCancelRecording = () => {
    try {
      // First stop the recording
      Mp3Recorder.stop();
      // Clean up the microphone stream
      if (Mp3Recorder && Mp3Recorder.mediaRecorder) {
        // Stop all tracks in the stream
        if (Mp3Recorder.mediaRecorder.stream) {
          Mp3Recorder.mediaRecorder.stream.getTracks().forEach(track => {
            track.stop();
            track.enabled = false;
          });
        }
        // Stop the media recorder
        if (Mp3Recorder.mediaRecorder.state !== 'inactive') {
          Mp3Recorder.mediaRecorder.stop();
        }
      }
      // Create a new instance of Mp3Recorder for next recording
      setMp3Recorder(new MicRecorder({ bitRate: 128 }));
    } catch (e) {
      console.error("Error stopping recorder:", e);
    } finally {
      clearInterval(recorderRef.current);
      setRecordingTime(0);
      setIsRecording(false);
      setAudioText("");
      setProcessAudio(false);
      trackEvent("audio_screen_closed", "Click", "Number of times users clicked on close icon from the screen");
    }
  };
  

  const startRecordingOnboarding = () => {
    try {
      if(!isLoading) {
        stopPlayingAudio(audioRef);
        setSpeakerEnabled(false);
        setIsRecordOnboarding(true);
        setTimeout(() => {
          setIsRecordOnboarding(false);
          startRecording();
        }, 3 * onboarding_delay);
      }
    } catch(error) {
      console.error("Error startig audio recording onboarding:", error);
    }
    trackEvent("mic_button_clicked", "Click", "Number of times users clicked on the mic button");
  }

  const stopRecording = () => {
    try {
      // First stop the recording
      Mp3Recorder.stop()
        .getMp3()
        .then(async ([buffer, blob]) => {
          setProcessAudio(true);
          if (recordingTime > 100) {
            setToastErrorMessage("Audio length too long");
            setToastMessageSeverity(ToastSeverityMap.error);
            setShowToastMessage(true);
            setInput("");
            setIsRecording(false);
            setAudioText("");
            setProcessAudio(false);
            setRecordingTime(0);
            return;
          }
          const res = await transcribe(getUserToken(), selectedLanguageCode, blob);
          if (res?.status === 200) {
            setInput(res?.data?.transcript?.text);
            const audioObj = {
              "url": res?.data?.gcs_path,
              "transcript": res?.data?.transcript?.text,
              "length": recordingTime
            }
            setAudioArr([...audioArr, audioObj]);
            setIsRecording(false);
            setAudioText(res?.data?.transcript?.text);
            setProcessAudio(false);
            setRecordingTime(0);
          }
          else if (res?.response?.status === 401) {
            localStorage.clear();
            sessionStorage.clear();
            navigate("/");
          }
          else if (res?.response?.status === 500) {
            setToastErrorMessage(res?.response?.data?.detail);
            setToastMessageSeverity(ToastSeverityMap.error);
            setShowToastMessage(true);
            setInput("");
            setIsRecording(false);
            setAudioText("");
            setProcessAudio(false);
            setRecordingTime(0);
          }
          else {
            setToastErrorMessage("Audio Transcription Failed");
            setToastMessageSeverity(ToastSeverityMap.error);
            setShowToastMessage(true);
            setInput("");
            setIsRecording(false);
            setAudioText("");
            setProcessAudio(false);
            setRecordingTime(0);
          }
        })
        .catch((error) => {
          setToastErrorMessage(error?.data?.transcript?.text);
          setToastMessageSeverity(ToastSeverityMap.error);
          setShowToastMessage(true);
          setInput("");
          setIsRecording(false);
          setAudioText("");
          setProcessAudio(false);
          setRecordingTime(0);
        });
    } catch (error) {
      console.error("Error stopping recording:", error);
    } finally {
      // Clean up the microphone stream
      if (Mp3Recorder && Mp3Recorder.mediaRecorder) {
        // Stop all tracks in the stream
        if (Mp3Recorder.mediaRecorder.stream) {
          Mp3Recorder.mediaRecorder.stream.getTracks().forEach(track => {
            track.stop();
            track.enabled = false;
          });
        }
        // Stop the media recorder
        if (Mp3Recorder.mediaRecorder.state !== 'inactive') {
          Mp3Recorder.mediaRecorder.stop();
        }
      }
      // Create a new instance of Mp3Recorder for next recording
      setMp3Recorder(new MicRecorder({ bitRate: 128 }));
      clearInterval(recorderRef.current);
      trackEvent("recording_stopped", "Click", "Number of times users clicked on stop button for stopping the recording");
    }
  };

  function sendText() {
    const trimmedInput = typeof input === "string" ? input.trim() : input;
    if (!isLoading && trimmedInput?.length > 0) {
      send(-1, trimmedInput, true, null);
      setInput("");
      setAudioText("");
      adjustTextareaHeight(true);
      sendClickedFunction();
    }
  }

  function sendMicText(inputText) {
    send(-1, inputText, true, null);
    setInput("");
    setAudioText("");
    trackEvent("voice_query_submitted", "Click", "Number of times users clicked send button for sending the transcripted text");
  }

  return (
    <div className="w-100">
      {normalizedInput.length === 0 && 
        <div
          id="tour-mic-button"
          className="flex items-center justify-center bg-[var(--border-color)] rounded-full cursor-pointer hover:bg-[var(--hover-primary-dark)] shadow-md w-[3.25rem] h-[3.25rem]"
          onClick={startRecordingOnboarding}
        >
          <img src={"/Assets/Images/mic.svg"} alt="Mic" className="h-[1.75rem]" />
        </div>
      }
      {normalizedInput.length > 0 && 
        <div
          id="tour-send-button"
          className={`flex items-center justify-center bg-[var(--border-color)] rounded-full cursor-pointer hover:bg-[var(--hover-primary-dark)] shadow-md w-[3.25rem] h-[3.25rem] ${normalizedInput.length > 0 ? '' : 'pointer-events-none'}`}
          onClick={sendText}
        >
          <img src={"/Assets/Images/send.svg"} alt="Send" className="h-[1.75rem]" />
        </div>
       } 
      {
        isRecording && <div>
            <div className='flex items-center justify-center bg-[var(--red-alert-2)] rounded-xl cursor-pointer w-[3.25rem] h-[3.25rem]' onClick={stopRecording}>
                <img src="/Assets/Images/stopIcon.svg" alt='Stop' className='h-[1.75rem]' />
            </div>
        </div>
      }
      {isRecordOnboarding && (
          <MicropohneOnboarding selectedLanguageCode={selectedLanguageCode} onboarding_delay={onboarding_delay} />
        )
      }
      {isRecording && (
        <AudioRecorder onCancelRecording={handleCancelRecording} setIsRecording={setIsRecording} selectedLanguageCode={selectedLanguageCode} recordingTime={recordingTime} onStop={stopRecording} showLoader={processAudio} />
      )}
      {audioText && (
        <RecordedAudioText
          audioText={audioText}
          selectedLanguageCode={selectedLanguageCode}
          send={sendMicText}
          setAudioText={setAudioText}
          setInput={setInput}
          setAudioArr={setAudioArr}
        />
      )}
    </div>
  );
};

export default ChatInputButton;
